export const IS_LOCAL = process.env.NODE_ENV === 'development'; // local or not
export const IS_PROD_ZONE = (process.env.PLATFORM_ENV ?? 'production') === 'production'; // production zone or not
export const getEnv = () => (IS_PROD_ZONE ? 'prod' : 'develop');
